import { Button, Col, notification, Row, Spin } from "antd";
import React, { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

import { GetAllMediclaimApi } from "../../../Services/EmployeeManager";
import { download, downloadBlob, downloadExcel } from "../../../Services/GeneralFunctions";

export default function MediclaimHr() {
  const [api, contextHolder] = notification.useNotification();
  const [tableLoader, setTableLoader] = useState(false);

  const mediclaimData = async () => {
    try {
      setTableLoader(true);
      const data = await GetAllMediclaimApi();
      setTableLoader(false);
      //   console.log(data.data.data.data);

      if (data.data.success) {
      } else {
        if (data) {
          download(new Blob([data.data], {type: "text/csv"}), 'result.csv');
          // downloadExcel(data?.data);
        } else {
          setTableLoader(false);
          api.error({
            message: "Error while fetching Employees List",
            description: data.data.message,
            placement: "top",
          });
        }
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Row
        className="py-2 box-shadow justify-content-between responsive-row default-background-color"
        style={{ borderRadius: "10px" }}
      >
        <Col className="py-2 no-display">
          <span style={{ fontSize: "20px" }}>Mediclaim</span>
        </Col>

        <Col lg={12} xs={24}>
          <Row className="justify-content-end">
            <Col className="p-1" sm={4} xs={24}>
              <Button
                className="action-button bg-success bs-opacity-75 bg-black text-center "
                style={{ width: "100%" }}
                onClick={mediclaimData}
                disabled={tableLoader}
                loading={tableLoader}
                iconPosition="end"
              >
                <span className="fw-bold">Export</span>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      {tableLoader && (
        <Row className="justify-content-center py-3">
          <Spin
            size="large"
            indicator={<LoadingOutlined className="" />}
            spinning={true}
          />
        </Row>
      )}
    </>
  );
}
